import {BaseEntity} from "./base-entity";

export class DriverLicenseInfo extends BaseEntity{
    name: string;
    surName: string;
    firstName: string;
    middleName: string;
    genderCode: string;
    birthDate: string; // yyyymmdd format
    licenseNumber: string;
    streetAddress: string;
    city: string;
    province: string;
    postalCode: string;
    placeOfIssue: string;
    expiryDate: string; // yyyymmdd format
    success: boolean = false;

    getFirstName() : string {
        if(this.firstName){
            return this.firstName;
        }
        if(this.name){
            const nameArr = this.name.split(',');
            return nameArr && nameArr.length ? nameArr[0] : '';
        } else {
            return '';
        }
    }

    getMiddleName() : string {
        if(this.middleName){
            return this.middleName;
        }
        if(this.name){
            const names = this.name.split(',');
            if(names && names.length > 1){
                names.shift();
                return names.toString();
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    get clientName() : string {
        return (this.getFirstName() ? (this.getFirstName()+' ') : '')+
            (this.getMiddleName() ? (this.getMiddleName()+' ') : '')+
            (this.surName ? this.surName : '');

    }

    get gender() : string {
        return this.genderCode == '1' ? 'MALE' : this.genderCode == '2' ? 'FEMALE' : '';
    }


    /**
     * This method format the date
     * @param input format is yyyymmdd
     * @param isPartialDate flag
     * @returns output format is dd/mm/yyyy if isPartialDate or otherwise yyyy-mm-dd T09:00:00.000Z
     */
    formatDate(input: string, isPartialDate?: boolean): string {
        if(input && input.length == 8){
            /*
            * When we choose a date in the date picker, the selection is stored and manipulated in GMT
            * Adding time to the date to avoid changing the date to the day before
            * According to Greenwich timezone, the least Canadian time zone is -7h so we are adding 9h to be safe
            */
            if(isPartialDate){
                return [input.slice(0, 4), '-', input.slice(4,6) , '-', input.slice(6) ].join('');
            } else {
                return  [input.slice(0, 4), '-', input.slice(4,6) , '-', input.slice(6) ].join('') + 'T09:00:00.000Z';
            }

        } else {
            return '';
        }
    }
}
